import React from 'react'
import { observer } from 'mobx-react-lite'
import SidebarFolderItem from './SidebarFolderItem'

export default observer(function SidebarFoldersList({ folders }) {

  return (
    <div>{ folders.map(folder => <SidebarFolderItem key={folder.id} folder={folder} />) }</div>
  )
})
